
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {getModule} from "vuex-module-decorators";
import {ShopModule, store} from "@returns-centre/store";
import {before} from "lodash";

@Component
export default class AppCheckmark extends Vue {
    shopModule = getModule(ShopModule, store);
    get getCustomColors(){
        if(!this.shopModule.shop) {
            return {};
        }
      document.documentElement.style.setProperty('--tickColor', this.shopModule.shop.return_centre_primary_action_color);
      return {
            backgroundColor: this.shopModule.shop.return_centre_primary_action_background_color,
            color: this.shopModule.shop.return_centre_primary_action_color,
        };
    }
};
